import React from "react";
import DropdownMenuIcon from "../icons/DropdownMenuIcon";

interface Props {
  children: React.ReactNode;
  onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const CustomToggle = React.forwardRef(({ children, onClick }: Props, ref) => (
  <button
    className="btn btn-light"
    ref={ref as any}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
    style={{ paddingBottom: "12px" }}
  >
    {children}
    <DropdownMenuIcon />
  </button>
));

CustomToggle.displayName = "ToggleMenu";

export default CustomToggle;
